export class Category {
    id: string;
    type: string;
    parent: string;
    name: string;
    everyoneCanDo: string;
    operator: string;
    vatRate: string;
    users: any[];
    children?: Category[];
}
